import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ColStyle = styled.div`
  .heading {
    font-size: 2.4rem;
    margin-bottom: 2rem;
  }
  li {
    margin-bottom: 1rem;
  }
  a {
    font-size: 1.8rem;
    color: var(--highlight-blue);
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.75;
    }
  }
  .link-icon {
    display: none;
    width: 28px;
    height: 28px;
    background-color: var(--highlight-blue);
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-position: center;
    mask-position: center;
    transition: background-color 0.3s ease, opacity 0.2s ease;
    &:hover {
      opacity: 0.7;
    }
  }
  .fa-link-icon {
    display: none;
    font-size: 2rem;
    color: var(--highlight-blue);
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.7;
    }
  }

  @media only screen and (max-width: 768px) {
    &.has-icons {
      ul {
        display: flex;
        flex-direction: row;
        gap: 1.6rem;
        flex-wrap: wrap;
        li {
          margin-bottom: 0;
        }
      }
      .link-text {
        display: none;
      }
      .link-icon {
        display: block;
      }
      .fa-link-icon {
        display: flex;
        align-items: center;
      }
    }
  }
`;

export default function FooterCol({
  heading = 'Col Heading',
  links = [
    {
      type: 'Link',
      title: 'Home',
      path: '/home',
    },
    {
      type: 'Link',
      title: 'About',
      path: '/about',
    },
  ],
}) {
  const hasIcons = links.some((l) => l.icon || l.faIcon);

  return (
    <ColStyle className={hasIcons ? 'has-icons' : ''}>
      <h2 className="heading">{heading}</h2>
      <ul>
        {links.map((item, index) => (
          <li key={index}>
            {item.type === 'Link' ? (
              <Link to={item.path} aria-label={item.title}>
                <span className="link-text">{item.title}</span>
                {item.faIcon && (
                  <span className="fa-link-icon">{item.faIcon}</span>
                )}
              </Link>
            ) : (
              <a href={item.path} target={item.target || '_self'} rel="noreferrer" aria-label={item.title}>
                <span className="link-text">{item.title}</span>
                {item.icon && (
                  <div
                    className="link-icon"
                    style={{
                      WebkitMaskImage: `url(${item.icon})`,
                      maskImage: `url(${item.icon})`,
                    }}
                  />
                )}
                {item.faIcon && (
                  <span className="fa-link-icon">{item.faIcon}</span>
                )}
              </a>
            )}
          </li>
        ))}
      </ul>
    </ColStyle>
  );
}
